export enum SortColumn {
  partNumber = 1,
  countryOfOrigin = 2,
  listPrice = 3,
  netPrice = 4,
  notifications = 5,
  atp = 6
}

export enum SortDirection {
  none = 0,
  asc = 1,
  desc = 2
}

export enum SortQuotes {
  none = 0,
  accountManager = 1,
  name = 2,
  quoteDate = 3,
  quoteStatus = 4,
  total = 5
}

export enum SortOrders {
  none = 0,
  accountManager = 1,
  accountName = 2,
  orderDate = 3,
  status = 4,
  total = 5
}

export enum SortAccounts {
  none = 0,
  name1 = 1,
  business = 2,
  priceMatrix = 3,
  address = 4,
  childName1 = 5
}

export enum LnOrderSortColumn {
  salesRepresentative = 1,
  customerName = 2,
  orderNumber = 3,
  orderDate = 4,
  orderPoNumber = 5,
  orderStatus = 6,
  orderTotalAmount = 7,
  orderQuoteNumber = 8
}

export enum SortLeads {
  none = 0,
  leadOwnerId = 1,
  companyInfo = 2,
  contact = 3,
  source = 4,
  date = 5,
  lastUpdated = 6,
  status = 7,
}

export enum SortProjects {
  none = 0,
  projectOwnerName = 1,
  date = 2,
  lastUpdated = 3,
  estimatedSalesValue = 4,
  estimatedSalesDate = 5
}
